<ng-container *ngIf="isMobile">
	<app-mobile-forget-passcode>
	</app-mobile-forget-passcode>
</ng-container>
<ng-container *ngIf="!isMobile">
	<app-web-forget-passcode>
	</app-web-forget-passcode>
</ng-container>
